import AccountType from '@/constants/AccountType';

export default class CurrentUserModel {
  name = '';

  account = '';

  id = '';

  accountType: AccountType=AccountType.PlateAccount;

  role: Array<string> = [];
}
